/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-bianma" /> 编码字典 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>

      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->
        <div class="optdiv">
          <div class="leftsearchbox">
            <div>
              <Input v-model="codeNum" placeholder="请输入编码" style="width: 150px" />
            </div>
            <div>
              <Select v-model="status" style="width: 200px">
                <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.value }}</Option>
              </Select>
            </div>
            <div>
              <Button class="tabdiv" @click="getDictona(1)" type="primary"
                ><Icon
                  style="font-size: 1rem; position: relative; top: -0.125rem"
                  type="ios-search"
                />&nbsp;搜索</Button
              >
            </div>

            <!-- <i-input class="tabdiv"  size="large" :value.sync="value" placeholder="请输入企业名称" style="width: 300px"></i-input>
            
					 -->
          </div>
          <div>
            <Button type="primary" @click="toAddCompany"
              ><Icon type="md-add" style="position: relative; top: -0.125rem" />&nbsp;新增编码</Button
            >
          </div>
        </div>
        <!-- 数据表格 -->
        <i-table width="100%" :columns="columns2" :data="dictionlist" :loading="tbLoading" />
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200, 500]"
          :page-size="row"
          show-total
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>

      <Modal v-model="modal1" title="删除提示" ok-text="确定删除" @on-ok="ok" @on-cancel="cancel">
        <Alert type="warning" show-icon>
          <template slot="desc"> 你确定要删除这个编码吗？你的删除可能会影响接受端程序出错的问题！ </template>
        </Alert>
      </Modal>
    </X-Layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      status: -1,
      statusList: [
        { id: -1, value: '全部' },
        { id: 2, value: '在线' },
        { id: 1, value: '油烟' },
        { id: 0, value: '工况' },
        { id: 3, value: '扬尘' },
      ],
      codeNum: '', // 编码
      modal1: false,
      listindex: '', // 删除数组中的第几个数据
      value: '',
      tbLoading: false, // 表格加载动画、
      editIndex: -1, // 编辑使用
      edit_code_name: '', // 编辑用编码
      edit_cn_name: '', // 编辑用中文名称
      edit_unit: '', // 编辑用计量单位
      icon: '', // 图标
      columns2: [
        {
          type: 'index',
          title: '序号',
          align: 'center',
          minWidth: 90,
          indexMethod: row => {
            return row._index + 1 + this.page * this.row - this.row;
          },
        },
        {
          title: '编码',
          align: 'center',
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: { width: '200px' },
                  props: { value: row.code_name },
                  on: {
                    input: val => {
                      this.edit_code_name = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.code_name;
            }
            return h('span', edit);
          },
        },
        {
          title: '中文名称',
          align: 'center',
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: { width: '200px' },
                  props: { value: row.cn_name },
                  on: {
                    input: val => {
                      this.edit_cn_name = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.cn_name;
            }
            return h('span', edit);
          },
        },
        {
          title: '计量单位',
          align: 'center',
          minWidth: 100,
          sortable: true,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: { width: '200px' },
                  props: { value: row.unit },
                  on: {
                    input: val => {
                      this.edit_unit = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.unit;
            }
            return h('span', edit);
          },
        },
        {
          title: '图标',
          align: 'center',
          minWidth: 100,
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h('Input', {
                  style: { width: '200px' },
                  props: { value: row.icon },
                  on: {
                    input: val => {
                      this.icon = val;
                    },
                  },
                }),
              ];
            } else {
              edit = row.icon;
            }
            return h('i', { class: edit });
          },
        },
        {
          title: '检测项',
          align: 'center',
          sortable: true,
          minWidth: 100,
          render: (h, column, params) => {
            if (column.row.status === 0) {
              // 工况
              return h('Tag', { props: { color: 'blue' } }, '工况');
            } else if (column.row.status === 1) {
              // 油烟
              return h('Tag', { props: { color: 'green' } }, '油烟');
            } else if (column.row.status === 2) {
              return h('Tag', { props: { color: 'yellow' } }, '在线');
            } else {
              return h('Tag', { props: { color: 'pink' } }, '扬尘');
            }
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 220,
          align: 'center',
          render: (h, { row, index }) => {
            let edit;
            if (this.editIndex === index) {
              // 判断编辑序号是否等会当前行索引
              edit = [
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small',
                      icon: 'md-create',
                    },
                    style: {
                      marginRight: '5px',
                    },
                    on: {
                      click: () => {
                        this.dictionlist[index].code_name = this.edit_code_name;
                        this.dictionlist[index].cn_name = this.edit_cn_name;
                        this.dictionlist[index].unit = this.edit_unit;
                        this.dictionlist[index].icon = this.icon;
                        this.editIndex = -1;
                        this.editOK(row.code_id);
                      },
                    },
                  },
                  '确认',
                ),
                h(
                  'Button',
                  {
                    props: {
                      type: 'error',
                      size: 'small',
                      icon: 'md-create',
                    },
                    style: {
                      marginRight: '5px',
                    },
                    on: {
                      click: () => {
                        this.editIndex = -1;
                      },
                    },
                  },
                  '取消',
                ),
              ];
            } else {
              edit = h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                    icon: 'md-create',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'editdictiona',
                        params: {
                          codeId: row.code_id,
                        },
                      });
                      // this.edit_code_name = row.code_name;
                      // this.edit_cn_name = row.cn_name;
                      // this.edit_unit = row.unit;
                      // this.icon = row.icon;
                      // this.editIndex = index;
                      // this.show2(column.row.code_id);
                    },
                  },
                },
                '修改编码',
              );
            }
            return h('div', [
              edit,
              h(
                'Icon',
                {
                  props: {
                    type: 'ios-trash',
                    title: '删除',
                  },
                  style: {
                    marginRight: '5px',
                    fontSize: '20px',
                    cursor: 'pointer',
                    color: '#ed4014',
                  },
                  on: {
                    click: () => {
                      this.deldata(row.code_id);
                    },
                  },
                },
                '删除',
              ),
            ]);
          },
        },
      ],
      dictionlist: [], // 字典信息
      total: 0, // 总条数
      page: 1, // 当前页数
      row: 20,
    };
  },

  mounted() {
    this.getDictona(1);
  },
  methods: {
    // 获取编码字典
    getDictona(page) {
      const api = this.ApiUrl + 'code/findAll';
      const params = {
        pageNo: page,
        pageSize: this.row,
        codeName: this.codeNum,
        status: this.status == -1 ? '' : this.status,
      };
      this.tbLoading = true; // 开启加载动画
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            this.dictionlist = res.data.extend.pageInfo.records;
            this.total = res.data.extend.pageInfo.total;
            this.page = page;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },

    /** *
     * 确定删除
     */
    ok() {
      const api = this.ApiUrl + 'code/delById';
      const data = {
        code_id: this.listindex,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            if (this.page > 1 && this.dictionlist.length == 1) {
              this.page -= 1;
            }
            this.getDictona(this.page);
          }
          this.$Message.success('成功删除');
        },
        res => {},
      );
    },
    /**
     * 对话框 取消事件
     */
    cancel() {
      this.$Message.info('取消删除');
    },

    // 表格删除事件
    deldata(index) {
      this.modal1 = true;
      this.listindex = index;
    },
    // 编辑确认按钮
    editOK(id) {
      const api = this.ApiUrl + 'code/updateCode';
      const data = {
        code_name: this.edit_code_name,
        cn_name: this.edit_cn_name,
        unit: this.edit_unit,
        icon: this.icon,
        code_id: id,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.data.extend.news === 0) {
            this.$Message.success('修改成功!');
          } else {
            this.$Message.error('修改失败!');
          }
        },
        res => {},
      );
    },
    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.getDictona(1);
    },
    // 切换下一页
    onNextPage(e) {
      this.getDictona(e);
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    /**
     * 点击确定事件1
     */
    clickOK1() {
      this.$Message.info('点击确认');
    },
    /**
     * 点击取消事件
     */
    clickCancel1() {
      this.$Message.info('点击取消');
    },
    /**
     * 删除事件
     */
    clickDel() {
      this.modal_loading = true; // 开启加载动画

      setTimeout(() => {
        this.modal_loading = false;
        this.modal2 = false;
        this.$Message.success('窗口隐藏');
      }, 2000);
    },

    /**
     * 跳转到添加企业
     */
    toAddCompany() {
      this.$router.push({
        name: 'newdictiona',
        params: { admid: 123 },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
  .leftsearchbox {
    display: flex;
    > div {
      margin-right: 5px;
    }
  }
}
</style>
